import React from 'react';
import CreateCuttingOrderModal from './CreateCuttingOrderModal';
import CuttingOrderDetailModal from './CuttingOrderDetailModal';
import CuttingConfigModal from './CuttingConfigModal';
import CutConfigLineModal from './CutConfigLineModal';
import CuttingFormLineModal from './CuttingFormLineModal';

// Component that renders all cutting order-related modals
const CuttingOrderModals: React.FC = () => {
  return (
    <>
      <CreateCuttingOrderModal />
      <CuttingOrderDetailModal />
      <CuttingConfigModal />
      <CutConfigLineModal />
      <CuttingFormLineModal cutType="cut_wood" />
    </>
  );
};

export default CuttingOrderModals;

// Export individual components
export {
  CreateCuttingOrderModal,
  CuttingOrderDetailModal,
  CuttingConfigModal,
  CutConfigLineModal,
  CuttingFormLineModal,
};
